import {
  Box,
  Button,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import axios from "axios";
import { useNavigate } from "react-router-dom";
import { baseUrl, getLatestBurdenAPI } from "../../Redux/App/app.actions";
import { handleDownload } from "../History/History";
import {
  mixpanelTrackButton,
  mixpanelTrackTabs,
} from "../utils/mixpanelFunctions";
import Deviation from "./Deviation";
import { Burden } from "./Tabs/Burden";
import { Health } from "./Tabs/Health";
import { SlagAlloyTable } from "./Tabs/SlagAlloyTable";

const Output = () => {
  const response = useSelector((state) => state.app.response);
  const [tabName, setTabName] = useState("Slag Alloy Table");
  const [maximum_numberof_charges, set_maximum_numberof_charges] = useState("");
  const [maximum_charges_caused_by, set_maximum_charges_caused_by] =
    useState("");
  // console.log(response);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useToast();
  const [isSaving, setIsSaving] = useState({
    isLoading: false,
    isError: false,
  });
  const handleSaveInHistory = async () => {
    setIsSaving({
      isLoading: true,
      isError: false,
    });
    try {
      if (!response?._id) {
        toast({
          title: "Error",
          description: "No response ID found",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      const url = `${baseUrl}/b1/save_history`;
      const data = {
        id: response._id,
        save: true,
      };

      const res = await axios.post(url, data);

      if (res.status === 200) {
        toast({
          title: "Success",
          description: "Successfully saved to history",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        setIsSaving({
          isLoading: false,
          isError: false,
        });
      }
    } catch (error) {
      console.error("Error saving to history:", error);
      toast({
        title: "Error",
        description: "Failed to save to history",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      setIsSaving({
        isLoading: false,
        isError: true,
      });
    }
  };

  useEffect(() => {
    dispatch(getLatestBurdenAPI());
  }, []);

  useEffect(() => {
    let max_charges_possible = Infinity;
    let max_charges_element = "";

    let exclude_elements_type = ["QRTZ", "BXT", "COKE_CO", "COAL_AN"];

    if (response?.output?.best_individual_burden?.length) {
      response.output.best_individual_burden.forEach((x) => {
        if (exclude_elements_type.includes(x.Type) == false) {
          let qty_available = x["QTY(kgs)"];
          let qty_used = x["Qty used(Kgs)"];
          let charges = Math.floor(qty_available / qty_used);
          if (charges < max_charges_possible) {
            max_charges_possible = charges;
            max_charges_element = x;
          }
        }
      });
      set_maximum_charges_caused_by((prev) => max_charges_element);
      set_maximum_numberof_charges((prev) => max_charges_possible);
    }
  }, [response]);
  useEffect(() => {
    mixpanelTrackTabs(tabName, "latest"); // track tabs
  }, [tabName]);

  const CustomTab = ({ text }) => {
    return (
      <Tab
        _selected={{
          borderBottom: "3px solid #1a174e",
          backgroundColor: "gray.200",
          borderRadius: "5px 5px 0 0",
        }}
        onClick={() => setTabName(text)}
      >
        {text}
      </Tab>
    );
  };

  if (Object?.keys(response)?.length > 0) {
    return (
      <Tabs isFitted w="100%">
        <TabList mb="1em">
          <CustomTab text={"Slag Alloy Table"} />
          <CustomTab text={"Burden"} />
          <CustomTab text={"Health Card"} />
          <CustomTab text={"Deviation"} />
          <Button
            m="5px"
            colorScheme="blue"
            onClick={() => {
              handleDownload(response?._id);
              mixpanelTrackButton("latest", "download");
            }}
          >
            {/* <DownloadIcon />  */}
            <Text ml="5px">Download compiled burden</Text>
          </Button>
        </TabList>
        <div className="flex justify-end items-center px-3">
          <Button
            // isDisabled={activeStep === 2}
            isLoading={isSaving.isLoading}
            isDisabled={isSaving.isLoading}
            onClick={() => {
              handleSaveInHistory();
              mixpanelTrackButton("latest", "save in history"); // mixpanel track button
            }}
            bg="#131D4F"
            color="white"
            borderRadius="4px"
            height="35px"
          >
            Save
          </Button>
        </div>
        <TabPanels>
          <TabPanel>
            {/* slag alloy table */}
            <SlagAlloyTable
              data={response?.output?.slag_alloy_table}
              headers={[
                "index",
                "Cr",
                "Cr2O3",
                "Fe",
                "FeO",
                "Fe2O3",
                "MgO",
                "Si",
                "SiO2",
                "Al2O3",
                "CaO",
                "P",
                "S",
                "FC",
              ]}
            />
            {/* <BestIndividualBurden
              data={response?.output?.slag_alloy_table}
              headers={[
                "Cr",
                "Cr2O3",
                "Fe",
                "FeO",
                "Fe2O3",
                "MgO",
                "Si",
                "SiO2",
                "Al2O3",
                "CaO",
                "P",
                "S",
                "FC",
              ]}
            /> */}
          </TabPanel>

          <TabPanel>
            {/* burden table */}
            <Burden
              headers={[
                "R.M",
                "BIN NO",
                "L NO",
                "QTY/KG",
                "Cr",
                "Cr2O3",
                "Fe",
                "FeO",
                "Fe2O3",
                "MgO",
                "Si",
                "SiO2",
                "Al2O3",
                "CaO",
                "P",
                "S",
                "FC",
              ]}
              data={response?.output?.burden}
            />
            {/* <BestIndividualCalculatedBurden
              data={response?.output?.best_individual_burden}
              headers={[
                "Lot no.",
                "Description",
                "Type",
                "Stock qty (kgs)",
                "Qty used(Kgs)",
                "Cr",
                "Cr2O3",
                "Fe",
                "FeO",
                "Fe2O3",
                "MgO",
                "Si",
                "SiO2",
                "Al2O3",
                "CaO",
                "P",
                "S",
                "FC",
              ]}
            /> */}
          </TabPanel>
          <TabPanel>
            {/* health  */}
            <Health
              healthData={response?.output?.health_card}
              carbonData={response?.output?.carbon_control}
              siliconData={response?.output?.silicon_control}
            />
            {/* <HealthCard
              inputData={
                response?.output?.best_individual_health_card_input || []
              }
              outputData={
                response?.output?.best_individual_health_card_output || []
              }
              resistance_set_points={
                response?.output?.resistance_set_points || []
              }
              maximum_numberof_charges={maximum_numberof_charges}
              maximum_charges_caused_by={maximum_charges_caused_by}
            /> */}
          </TabPanel>
          <TabPanel>
            {/* deviation */}
            <Deviation
              data={response?.output?.deviation || []}
              headers={[
                "Health indicator",
                "Value",
                "Minimum recommended value",
                "Maximum recommended value",
                "Deviation",
              ]}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    );
  } else {
    return (
      <Box>
        <Box textAlign="center" py={10} px={6}>
          <Heading
            display="inline-block"
            as="h2"
            size="xl"
            bgGradient="linear(to-r, #15112e, #372c78)"
            backgroundClip="text"
          >
            No Burden created
          </Heading>
          <Text color={"gray.500"} mb={6}>
            Click on the below button to create a new Burden
          </Text>
          <Button
            onClick={() => navigate("/")}
            colorScheme="teal"
            _hover={{ bgGradient: "linear(to-r, #15112e, #372c78)" }}
            bgGradient="linear(to-r, #15112e, #372c78)"
            color="white"
            variant="solid"
          >
            create
          </Button>
        </Box>
      </Box>
    );
  }
};

export default Output;
